import {Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ViewChild} from '@angular/core';

import {LogService} from '../../../../services/log.service';

import {PageComponent} from '../page/page.component';
import {SidenavComponent} from '../sidenav/sidenav.component';
import {ScrollToTopComponent} from '../scroll-to-top/scroll-to-top.component';


@Component({
	selector: 'list-page',
	templateUrl: './list-page.component.html',
	styleUrls: ['./list-page.component.scss']
})
export class ListPageComponent extends PageComponent implements OnInit, AfterViewInit {
	// constructor(
	// 	private log: LogService
	// ) {
	// 	super(log);
	// }

	@ViewChild(SidenavComponent) sidenav: SidenavComponent;
	@ViewChild(ScrollToTopComponent) scrollToTop: ScrollToTopComponent;

	// @Input() contentSize: ContentSize = ContentSize.Small;
	// @Output() linkClick = new EventEmitter();


	ngOnInit() {
		super.ngOnInit();
		console.log('ListPageComponent, ngOnInit');
	}


	ngAfterViewInit() {
		super.ngAfterViewInit();
		console.log('ListPageComponent, ngAfterViewInit');

		console.log('ListPageComponent, this.sidenav');
		console.log(this.sidenav);

	}

}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/modules/shared/components/list-page/list-page.component.ts